<template>  
      <section class="panel panel-default">
        <header class="panel-heading">
          <div class="row">
            <div class="col-sm-12">
              <a
                v-on:click="$emit('show-form')"
                class="btn btn-success pull-right"
              >
                <i class="fa fa-plus"> </i> New {{title}}
              </a>
              <h4>
                <i class="fa fa-list-ul"></i>
                {{title}}
              </h4>
            </div>
          </div>
        </header>
        <div class="modal-body">
          <form @submit.prevent="getBrands()" method="post">
            <div class="row">
              <!-- <div class="col-sm-4">
                <div class="form-group">
                  <label> Category</label>
                  <select
                    class="form-control "
                    v-model="type_job"
                    id="type_job"
                    name="type_job"
                    style="width: 100%;"
                  >
                    <option value="0">Choose Job Type </option>
                    <option
                      v-for="(type, index) in jobTypes"
                      :key="index"
                      v-bind:value="index"
                      >{{ type }}</option
                    >
                  </select>
                </div>
              </div> 
              <div class="col-lg-4">
                <div class="form-group" style="padding-top: 25px;">
                  <button type="submit" class="btn btn-success">
                    &nbsp;&nbsp;&nbsp; Search &nbsp;&nbsp;&nbsp;
                  </button>
                   <a href="" class="btn btn-danger"
                    >&nbsp;&nbsp;&nbsp;&nbsp; Reset &nbsp;&nbsp;&nbsp;&nbsp;</a
                  >
                </div>
              </div> -->
            </div>
          </form>
        </div>
      </section>
</template>

<script>
export default {
  name: 'ListFilter',
  props: ["title"]
}
</script>
